import { NumberField, TanstackFieldWrapper } from 'components/form-fields-2';
import { useScenarioForm } from './contexts';
import commonStyles from './common.module.scss';
import styles from './peak-rate-detection-configs.module.scss';
import {
  AccordionDetails,
  Accordion,
  AccordionSummary,
} from 'components/accordion/accordion';
import { useState } from 'react';
import { Button, Checkbox } from '@carbon/react';
import { Reset } from '@carbon/react/icons';
import { ConfigSkeleton } from './config-skeleton';
import { isGeneralConfigModified } from './utils';

export const PeakRateDetectionConfigs = () => {
  const { form, defaultValues } = useScenarioForm();
  const [expanded, setExpanded] = useState(true);

  return (
    <Accordion expanded={expanded} onClick={() => setExpanded((prev) => !prev)}>
      <AccordionSummary>
        <h2 className={commonStyles.configFormTitle}>Peak Rate Detection</h2>
      </AccordionSummary>
      <AccordionDetails>
        <div className={commonStyles.configFormContainer}>
          <form.Subscribe selector={(state) => state.values.generalConfig}>
            {(generalConfig) => {
              const baseline = defaultValues?.generalConfig;
              const isModified =
                !!generalConfig &&
                !!baseline &&
                isGeneralConfigModified(generalConfig, baseline);

              return (
                <>
                  {!generalConfig && (
                    <ConfigSkeleton id="Peak Rate Detection" />
                  )}
                  {generalConfig && (
                    <>
                      <div className={styles.inputsContainer}>
                        {generalConfig.detectPeakRate && (
                          <form.Field name="generalConfig.peakRateSearchWindow">
                            {(field) => (
                              <TanstackFieldWrapper<number | null>
                                field={field}
                              >
                                {(props) => (
                                  <NumberField
                                    id="peakRateSearchWindow"
                                    label="Peak Rate Search Window"
                                    {...props}
                                  />
                                )}
                              </TanstackFieldWrapper>
                            )}
                          </form.Field>
                        )}

                        <div className={commonStyles.checkboxContainer}>
                          <form.Field name="generalConfig.detectPeakRate">
                            {(field) => (
                              <TanstackFieldWrapper<boolean> field={field}>
                                {(props) => (
                                  <Checkbox
                                    id="detectPeakRate"
                                    labelText="Detect Peak Rate"
                                    checked={props.value}
                                    onChange={(
                                      _evt,
                                      { checked }: { checked: boolean }
                                    ) => props.onChange(checked)}
                                  />
                                )}
                              </TanstackFieldWrapper>
                            )}
                          </form.Field>
                        </div>
                      </div>

                      <div className={commonStyles.buttonContainer}>
                        <Button
                          size="md"
                          kind="tertiary"
                          onClick={() => {
                            if (!baseline) return;
                            form.setFieldValue(
                              'generalConfig.peakRateSearchWindow',
                              baseline.peakRateSearchWindow
                            );
                            form.setFieldValue(
                              'generalConfig.detectPeakRate',
                              baseline.detectPeakRate
                            );
                          }}
                          renderIcon={Reset}
                          disabled={!isModified}
                        >
                          Reset
                        </Button>
                      </div>
                    </>
                  )}
                </>
              );
            }}
          </form.Subscribe>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
